import { render, staticRenderFns } from "./SubjectProduct.vue?vue&type=template&id=34067d52&scoped=true"
import script from "./SubjectProduct.vue?vue&type=script&lang=js"
export * from "./SubjectProduct.vue?vue&type=script&lang=js"
import style0 from "./SubjectProduct.vue?vue&type=style&index=0&id=34067d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34067d52",
  null
  
)

export default component.exports